import { ReviewStatusDotState } from '../../utils/reviewStatusDot';

export const REVIEW_STATUS_DOT_FILTER_OPTIONS: {
  value: ReviewStatusDotState;
  label: string;
}[] = [
  { value: 'red', label: 'שדות קריטיים חסרים' },
  { value: 'grey', label: 'טרם נבדוק' },
  { value: 'pink', label: 'חסר L2' },
  { value: 'green', label: 'נבדק ונשמר' },
];

export const ALL_REVIEW_STATUS_DOT_STATES: ReviewStatusDotState[] = [
  'red',
  'grey',
  'pink',
  'green',
];
